import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';

const Footer = () => (
  <footer className="bg-slate-900 text-white py-16" data-testid="global-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center">
              <MessageSquare className="w-5 h-5 text-white" />
            </div>
            <span className="font-bold text-xl">Flowteras</span>
          </div>
          <p className="text-slate-400 text-sm">WhatsApp-native Business Operating System</p>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Product</h4>
          <div className="flex flex-col gap-2 text-slate-400 text-sm">
            <Link to="/product" className="hover:text-white transition-colors">Features</Link>
            <Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link>
            <Link to="/about" className="hover:text-white transition-colors">About</Link>
          </div>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Support</h4>
          <div className="flex flex-col gap-2 text-slate-400 text-sm">
            <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
            <a href="#" className="hover:text-white transition-colors">Documentation</a>
            <a href="#" className="hover:text-white transition-colors">API</a>
          </div>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Legal</h4>
          <div className="flex flex-col gap-2 text-slate-400 text-sm">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-800 mt-12 pt-8 text-center text-slate-400 text-sm" data-testid="footer-legal-attribution">
        <p>&copy; {new Date().getFullYear()} Flowteras. All rights reserved.</p>
        <p className="mt-2">Developed and operated by GREENMOUNT SOLUTIONS SDN. BHD. (Malaysia).</p>
      </div>
    </div>
  </footer>
);

export default Footer;
